
<p-dialog 
[header]="'CUSTOMER_FIELDS.TITLE' | translate"
[style]="{width: '450px'}" [(visible)]="displayDialog"  [modal]="true" [closable]="true"
(onHide)="closeDialog()" class="custom-dialog" >
<form>
        <div class="p-fluid" *ngFor="let field of customerFields; let i = index" class="mb-4">
          <div class="p-field">
            <label for="fieldName{{ i }}">{{'CUSTOMER_FIELDS.FIELD_NAME'|translate}}</label>
            <input pInputText id="fieldName{{ i }}" [(ngModel)]="field.FieldName" name="fieldName{{ i }}" />
          </div>
          <div class="p-field">
            <label for="fieldType{{ i }}">{{'CUSTOMER_FIELDS.FIELD_TYPE'|translate}}</label>
            <p-dropdown id="fieldType{{ i }}" [options]="fieldTypes" optionLabel="label" optionValue="value"
                        [(ngModel)]="field.FieldType" name="fieldType{{ i }}"></p-dropdown>

          </div>
          <div class="p-field">
            <label for="fieldRequired{{ i }}">{{'CUSTOMER_FIELDS.REQUIRED' | translate}}</label>
            <!-- <br> -->
            <p-checkbox name="fieldRequired{{ i }}" [(ngModel)]="field.Required" (ngModelChange)="field.Required = $event"   [binary]="true" ></p-checkbox>
          </div>
          <hr>
        </div>      
</form>

</p-dialog>
